<app-kpi-planning-analytics-schedule-chart-view
    [data]="scheduleData | async"
    [start]="startRange$ | async"
    [end]="endRange$ | async"
></app-kpi-planning-analytics-schedule-chart-view>
